{
   "templates": {
      "termsAndConditions": "terms and conditions",
      "privacyPolicy": "privacy policy"
   },
   "common": {
      "email": "email",
      "password": "password",
      "currentPassword": "current password",
      "newPassword": "new password",
      "confirmPassword": "confirm password",
      "name": "name",
      "fullName": "full name",
      "phone": "phone number",
      "description": "description",
      "color": "color",
      "or": "or",
      "of": "of",
      "step": "step",
      "continue": "continue",
      "back": "back",
      "save": "save",
      "create": "create",
      "edit": "edit",
      "share": "share",
      "property": "property",
      "properties": "properties",
      "workspace": "workspace",
      "workspaces": "workspaces",
      "item": "item",
      "items": "items",
      "member": "member",
      "members": "members",
      "enabled": "enabled",
      "disabled": "disabled",
      "open": "open",
      "cancel": "cancel",
      "list": "list",
      "grid": "grid",
      "price": "price",
      "maintenanceFee": "maintenance fee",
      "status": "status",
      "area": "area",
      "livingArea": "living area",
      "landArea": "land area",
      "commonArea": "common area",
      "bed": "bed",
      "beds": "beds",
      "floor": "floor",
      "floors": "floors",
      "built": "built",
      "notes": "notes",
      "room": "room",
      "rooms": "rooms"
   },
   "components": {
      "alert": {
         "info": {
            "title": "info"
         },
         "success": {
            "title": "success"
         },
         "warning": {
            "title": "warning"
         },
         "error": {
            "title": "error"
         }
      },
      "decorations": {
         "priceTrend": "price trend",
         "property": {
            "address": "Cherni Vrah 52, Sofia"
         },
         "totalTracked": "total tracked",
         "family": "petrov family",
         "membersList": {
            "title": "team members",
            "description": "shared with your team",
            "description2": "shared with",
            "member1": "ik",
            "member2": "ml",
            "member3": "sh"
         },
         "organizationName": "organization name"
      },
      "sideMenu": {
         "main": "main",
         "dashboard": "dashboard",
         "companyProperties": "company properties",
         "trackedProperties": "tracked properties",
         "workspaces": "workspaces",
         "notifications": "notifications",
         "account": "account",
         "settings": "settings",
         "support": "support"
      },
      "footer": {
         "productOf": "product of {brandName}",
         "copyright": "© {year} {brandName}. all rights reserved."
      },
      "form": {
         "passwordRule": "at least 8 characters, one number",
         "nothingToSave": "nothing to save yet"
      },
      "confirmationWrapper": {
         "title": "are you sure?",
         "message": "do you really want to continue? this action may be irreversible."
      },
      "workspaceModal": {
         "title": {
            "create": "create workspace",
            "edit": "edit workspace"
         },
         "form": {
            "nameTooltip": "example: Petrovi family"
         }
      },
      "workspaceShareModal": {
         "description": {
            "PERSONAL": "share with up to {membersLimit} people",
            "AGENCY": "share with up to {membersLimit} external people. company members can be added directly"
         }
      },
      "propertyCard": {
         "menuActions": {
            "open": "open",
            "openInNewTab": "open in new tab",
            "archive": "archive",
            "delete": "delete"
         }
      }
   },
   "api": {
      "success": {
         "default": "Success",
         "list": {
            "userRegistered": "user registered",
            "userLoggedIn": "user logged in",
            "userLoggedOut": "user logged out",
            "userUpdated": "user updated",
            "accountDeleted": "account deleted",
            "emailVerificationSent": "email verification sent",
            "profileImageUpdated": "profile image updated",
            "passwordChanged": "password changed",
            "passwordSet": "password set",
            "organizationCreated": "organization created",
            "organizationEdited": "organization edited",
            "propertyEdited": "property edited",
            "propertyArchived": "property archived",
            "propertyUnarchived": "property unarchived",
            "workspaceCreated": "workspace created",
            "workspaceEdited": "workspace edited",
            "workspaceArchived": "workspace archived",
            "workspaceUnarchived": "workspace unarchived",
            "workspaceShareLinkCreated": "workspace share link was created"
         }
      },
      "warnings": {
         "default": "Warning",
         "list": {
            "logInAgainToDeleteAccount": "please log in again to delete your account",
            "logInAgainToChangePassword": "please log in again to change your password",
            "cannotChangePassword": "cannot change password"
         }
      },
      "errors": {
         "default": "something went wrong",
         "server": "problem with the server",
         "notFound": "not found",
         "list": {
            "cannotSendEmailVerification": "cannot send email verification",
            "cannotUpdateUserData": "cannot update user data",
            "cannotUpdateUserDataDescription": "there was a problem updating the user data. please try again later.",
            "auth/claims-too-large": "something went wrong with the authentication",
            "auth/email-already-exists": "email already exists",
            "auth/id-token-expired": "user session expired",
            "auth/id-token-revoked": "user session expired",
            "auth/insufficient-permission": "something went wrong with the authentication",
            "auth/internal-error": "something went wrong with the authentication",
            "auth/invalid-argument": "something went wrong with the authentication",
            "auth/invalid-claims": "something went wrong with the authentication",
            "auth/invalid-continue-uri": "something went wrong with the authentication",
            "auth/invalid-creation-time": "something went wrong with the authentication",
            "auth/invalid-credential": "credentials are not valid",
            "auth/invalid-disabled-field": "something went wrong with the authentication",
            "auth/invalid-display-name": "name is not valid",
            "auth/invalid-dynamic-link-domain": "something went wrong with the authentication",
            "auth/invalid-email": "email is not valid",
            "auth/invalid-email-verified": "email verification had a problem",
            "auth/invalid-hash-algorithm": "something went wrong with the authentication",
            "auth/invalid-hash-block-size": "something went wrong with the authentication",
            "auth/invalid-hash-derived-key-length": "something went wrong with the authentication",
            "auth/invalid-hash-key": "something went wrong with the authentication",
            "auth/invalid-hash-memory-cost": "something went wrong with the authentication",
            "auth/invalid-hash-parallelization": "something went wrong with the authentication",
            "auth/invalid-hash-rounds": "something went wrong with the authentication",
            "auth/invalid-hash-salt-separator": "something went wrong with the authentication",
            "auth/invalid-id-token": "something went wrong with the authentication",
            "auth/invalid-last-sign-in-time": "something went wrong with the authentication",
            "auth/invalid-page-token": "something went wrong with the authentication",
            "auth/invalid-password": "password is not valid",
            "auth/invalid-password-hash": "password is not valid",
            "auth/invalid-password-salt": "password is not valid",
            "auth/invalid-phone-number": "phone number is not valid",
            "auth/invalid-photo-url": "something went wrong with the authentication",
            "auth/invalid-provider-data": "something went wrong with the authentication",
            "auth/invalid-provider-id": "something went wrong with the authentication",
            "auth/invalid-oauth-responsetype": "something went wrong with the authentication",
            "auth/invalid-session-cookie-duration": "something went wrong with the authentication",
            "auth/invalid-uid": "something went wrong with the authentication",
            "auth/invalid-user-import": "something went wrong with the authentication",
            "auth/maximum-user-count-exceeded": "something went wrong with the authentication",
            "auth/missing-android-pkg-name": "something went wrong with the authentication",
            "auth/missing-continue-uri": "something went wrong with the authentication",
            "auth/missing-hash-algorithm": "something went wrong with the authentication",
            "auth/missing-ios-bundle-id": "something went wrong with the authentication",
            "auth/missing-uid": "something went wrong with the authentication",
            "auth/missing-oauth-client-secret": "something went wrong with the authentication",
            "auth/operation-not-allowed": "something went wrong with the authentication",
            "auth/phone-number-already-exists": "phone number already exists",
            "auth/project-not-found": "something went wrong with the authentication",
            "auth/reserved-claims": "something went wrong with the authentication",
            "auth/session-cookie-expired": "user session expired",
            "auth/session-cookie-revoked": "user session expired",
            "auth/too-many-requests": "Too many requests. Try again later",
            "auth/uid-already-exists": "something went wrong with the authentication",
            "auth/unauthorized-continue-uri": "something went wrong with the authentication",
            "auth/user-disabled": "something went wrong with the authentication",
            "auth/user-not-found": "something went wrong with the authentication",
            "storage/unknown": "something went wrong with the storage",
            "storage/object-not-found": "something went wrong with the storage",
            "storage/bucket-not-found": "something went wrong with the storage",
            "storage/project-not-found": "something went wrong with the storage",
            "storage/quota-exceeded": "too many requests. try again later",
            "storage/unauthenticated": "something went wrong with the storage",
            "storage/unauthorized": "something went wrong with the storage",
            "storage/retry-limit-exceeded": "too many requests. try again later",
            "storage/invalid-checksum": "something went wrong with the storage",
            "storage/canceled": "action canceled",
            "storage/invalid-event-name": "something went wrong with the storage",
            "storage/invalid-url": "something went wrong with the storage",
            "storage/invalid-argument": "something went wrong with the storage",
            "storage/no-default-bucket": "something went wrong with the storage",
            "storage/cannot-slice-blob": "something went wrong with the storage",
            "storage/server-file-wrong-size": "something went wrong with the storage"
         }
      }
   },
   "enums": {
      "dayOfWeek": {
         "monday": "monday",
         "tuesday": "tuesday",
         "wednesday": "wednesday",
         "thursday": "thursday",
         "friday": "friday",
         "saturday": "saturday",
         "sunday": "sunday"
      },
      "time": {
         "day": "day",
         "month": "month"
      },
      "countries": {
         "BG": "Bulgaria"
      },
      "measurementUnit": {
         "metric": "metric",
         "imperial": "imperial"
      },
      "organizationType": {
         "PERSONAL": "personal",
         "AGENCY": "agency organization"
      },
      "dealType": {
         "SALE": "sale",
         "RENT": "rent"
      },
      "propertyAvailability": {
         "ACTIVE": "active",
         "RESERVED": "reserved",
         "SOLD": "sold",
         "RENTED": "rented",
         "EXPIRED": "expired",
         "TAKEN_DOWN": "taken down",
         "UNKNOWN": "unknown"
      },
      "propertySpaceKind": {
         "PARKING_SPACE": "parking space",
         "GARAGE": "garage",
         "BALCONY": "balcony",
         "LOGGIA": "loggia",
         "TERRACE": "terrace",
         "ROOF_TERRACE": "roof terrace",
         "YARD": "yard",
         "BASEMENT": "basement",
         "STORAGE": "storage",
         "ATTIC": "attic",
         "BATHROOM": "bathroom",
         "BATHROOM_WITH_TOILET": "bathroom & toilet",
         "TOILET": "toilet",
         "POOL": "pool",
         "SAUNA": "sauna",
         "WINTER_GARDEN": "winter garden",
         "OTHER": "other"
      },
      "propertySpacePlacement": {
         "UNDERGROUND": "underground",
         "COVERED": "covered",
         "OUTDOOR": "outdoor",
         "INTERNAL": "indoor",
         "UNKNOWN": "unknown"
      },
      "propertySpaceSaleType": {
         "INCLUDED": "included",
         "EXTRA_OPTIONAL": "optional",
         "EXTRA_REQUIRED": "extra required",
         "UNKNOWN": "unknown"
      }
   },
   "pages": {
      "errorPage": {
         "home": "home"
      },
      "auth": {
         "register": {
            "title": "create your account",
            "description": "it takes less than a minute, no card required.",
            "createAccount": "create account",
            "agreeToText": "creating an account means you agree to our {termsAndConditions} and {privacyPolicy}.",
            "alreadyHaveAccount": "already have an account?"
         },
         "login": {
            "title": "welcome back",
            "description": "log in to see what changed with your tracked properties.",
            "logIn": "log in",
            "doNotHaveAccount": "don't have an account?"
         },
         "continueWithGoogle": "continue with google",
         "marketingText": "track every listing you care about, across every site, in one place."
      },
      "organization": {
         "create": {
            "steps": {
               "1": {
                  "title": "how will you use",
                  "description": "this sets up your first organization. you can create more later.",
                  "options": {
                     "PERSONAL": {
                        "title": "personal use",
                        "description": "track properties you're personally interested in buying or renting."
                     },
                     "AGENCY": {
                        "title": "agency",
                        "description": "collaborate with your team and share listings with clients."
                     }
                  }
               },
               "2": {
                  "titlePersonal": "name your team",
                  "title": "name your organization",
                  "description": "you can change the name at any time from settings.",
                  "namePersonal": "team name",
                  "name": "organization name"
               },
               "3": {
                  "title": "invite your colleagues",
                  "description": "add team members to collaborate on listings and client folders.",
                  "emailError": "Invalid email"
               }
            },
            "submitButton": {
               "PERSONAL": "create team & finish",
               "AGENCY": "send invites & finish"
            },
            "skip": "skip for now",
            "marketingText": "invite your colleagues so everyone sees the same listings and client folders."
         }
      },
      "dashboard": {
         "title": "welcome back",
         "description": "here's what changed across your organization"
      },
      "properties": {
         "title": {
            "PERSONAL": "tracked properties",
            "AGENCY": "company properties"
         },
         "description": {
            "PERSONAL": "track and manage all your properties in one place",
            "AGENCY": "track and manage all company properties in one place"
         },
         "createWorkspace": "create workspace",
         "emptyStateMessage": "no properties found",
         "folderView": "folder view",
         "flatList": "flat list"
      },
      "notifications": {
         "title": "notifications"
      },
      "addProperty": {
         "title": "track a property",
         "description": "paste a listing url and we'll pull in the details automatically",
         "backButton": "cancel and go back",
         "fields": {
            "url": "listing url",
            "urlError": "Invalid url",
            "addTo": "add to"
         },
         "submitButton": "start tracking",
         "scraping": {
            "steps": {
               "FETCHING": {
                  "title": "fetching the listing",
                  "description": "we're pulling in the details from the listing page"
               },
               "READING": {
                  "title": "reading listing data",
                  "description": "we're analyzing the listing to extract all the important details"
               },
               "STRUCTURING": {
                  "title": "structuring the data",
                  "description": "we're organizing the information into a clear, easy-to-read format"
               },
               "FINALIZING": {
                  "title": "finalizing",
                  "description": "we're getting everything ready for you"
               }
            },
            "finish": {
               "title": "got it — property tracked",
               "description": "we've pulled in all the details and organized them for you"
            }
         },
         "actions": {
            "trackAnother": "track another",
            "viewProperty": "view property",
            "tryAgain": "try again"
         },
         "failed": {
            "title": "oops — something went wrong",
            "description": "we couldn't track the property. please try again or contact support."
         }
      },
      "singleProperty": {
         "trackedSince": "tracked since",
         "spaces": "spaces",
         "emptyStateMessage": "no property found"
      },
      "workspaces": {
         "title": "workspaces",
         "emptyStateMessage": "no workspaces found"
      },
      "account": {
         "title": "account",
         "logOut": "log out",
         "sections": {
            "account": {
               "memberSince": "member since",
               "profileImage": {
                  "remove": "remove photo"
               }
            },
            "personalInfo": {
               "title": "personal info",
               "description": "update your personal details and contact information.",
               "form": {
                  "emailInfoText": "to change your email, contact support."
               }
            },
            "signInSecurity": {
               "title": "sign-in & security",
               "description": "manage your sign-in methods and security settings.",
               "providers": {
                  "google": "google",
                  "password": "email & password",
                  "notSupported": "unsupported provider"
               },
               "password": {
                  "change": {
                     "title": "change password",
                     "submitButton": "update password"
                  },
                  "set": {
                     "title": "set password",
                     "submitButton": "set password"
                  },
                  "errors": {
                     "passwordsDoNotMatch": "passwords do not match"
                  }
               }
            },
            "dataPrivacy": {
               "title": "data & privacy",
               "items": {
                  "requestMyData": "request a copy of my data",
                  "requestMyDataDescription": "we'll get back to you by email - this is handled by our team, not an instant download."
               },
               "contactSupport": "contact support"
            },
            "deleteAccount": {
               "title": "delete account",
               "description": "your personal workspace and any agency you own are archived with you. notes you wrote elsewhere stay, credited to \"deleted user\".",
               "deleteButton": "delete account"
            }
         }
      },
      "settings": {
         "title": "settings",
         "sections": {
            "general": {
               "title": "general",
               "description": "how the app behaves",
               "fields": {
                  "weakStartDay": "weak start day",
                  "weakStartDayDescription": "choose which day of the week is considered the start of the week",
                  "measurementUnit": "measurement unit",
                  "measurementUnitDescription": "areas and distances are converted on display only"
               }
            },
            "appearance": {
               "title": "appearance",
               "description": "customize the look and feel of the app",
               "fields": {
                  "language": "language",
                  "languageDescription": "choose your preferred language for the interface"
               }
            },
            "notifications": {
               "title": "notifications",
               "description": "manage your notification preferences",
               "headers": {
                  "event": "event",
                  "inApp": "in-app",
                  "email": "email"
               },
               "events": {
                  "priceChanges": "price changes",
                  "priceChangesDescription": "a tracked property's price goes up or down",
                  "availabilityChanges": "availability changes",
                  "availabilityChangesDescription": "important status changes like sold, rented, reserved, expired and others",
                  "activityDigest": "activity digest",
                  "activityDigestDescription": "a summary of your recent activity once a week"
               }
            },
            "organization": {
               "title": "organization",
               "description": "manage your organization settings",
               "form": {
                  "fields": {
                     "organizationName": "organization name",
                     "contactEmail": "contact email",
                     "contactPhone": "contact phone number",
                     "website": "website url"
                  }
               }
            }
         }
      },
      "support": {
         "title": "support"
      }
   }
}
